function alignCraftsmanshipImageEdge() {
  const banner = document.querySelector('.bm-accessories__banner');
  const media = document.querySelector('.bm-craftsmanship__media');
  if (!banner || !media) return;
  const update = () => {
    const crop = Math.max(0, media.getBoundingClientRect().width - banner.getBoundingClientRect().width);
    media.style.setProperty('--bm-image-right-crop', crop + 'px');
    media.classList.add('bm-craftsmanship__media--width-match');
  };
  update();
  const observer = new ResizeObserver(update);
  observer.observe(banner);
  observer.observe(media);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alignCraftsmanshipImageEdge, {once:true});
else alignCraftsmanshipImageEdge();
document.addEventListener('shopify:section:load', alignCraftsmanshipImageEdge);
